import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd'; // Import Pagination component from Ant Design
import images from '../../themes/appImage';
import InnerImgCard from './InnerImgCard';
import { useDispatch, useSelector } from 'react-redux';
import { adminGetCircleListLoad } from '../../redux/slices/adminInner.slice';
import { imageURL } from '../../redux/Api/apikit';

const apiPayloadInit = {
  offset: 0,
  limit: 10
}

const InnerImgCards = ({ userListDetailId, myid }) => {
  const dispatch = useDispatch();
  const [apiPayload, setApiPayload] = useState({
    ...apiPayloadInit,
    circle: userListDetailId,
    organisation: myid
  })

  const { circleListData, isLoading } = useSelector(state => state.adminInnerReducer);
  const [localCircleListData, setLocalCircleListData] = useState([])


  useEffect(() => {
    dispatch(adminGetCircleListLoad({ ...apiPayload, circle: userListDetailId }));
  }, [userListDetailId]);

  useEffect(() => {
    setLocalCircleListData(pre => [...pre, ...circleListData])
  }, [circleListData]);


  const handlerShowMoreCommentsHandler = () => {
    const updateOffset = apiPayload.offset + apiPayload.limit
    const data = {
      ...apiPayload,
      offset: updateOffset,
    };
    dispatch(adminGetCircleListLoad(data));
    setApiPayload(pre => ({ ...pre, offset: updateOffset }))
  }
  return (
    <div>
      <div className='flex flex-col gap-4 mt-4'>
        {isLoading === false ? (
          localCircleListData?.map(({ text, file, postType, createdAt, creatorData, happyFace, partyFace, redHeart, smileyFace, smileyHeart, comment, _id }, key) => (
            <InnerImgCard
              key={key}
              avatarSrc={creatorData?.avatar ? `${imageURL}${creatorData.avatar}` : images.defaultAvatar}
              username={creatorData?.userName}
              time={createdAt}
              description={text}
              file={file}
              postType={postType}
              coverSrc={images.cardCover}
              commentSrc={images.commentImg}
              hugSrc={images.hug}
              happyFace={happyFace}
              partyFace={partyFace}
              redHeart={redHeart}
              smileyFace={smileyFace}
              smileyHeart={smileyHeart}
              comment={comment}
              id={_id}
            />
          ))
        ) : (
          "Loading..."
        )}
        {localCircleListData?.length == 0 && isLoading == false && <div className="text-lg w-full flex justify-center text-black">No Feeds</div>}
      </div>
      {/* Pagination Component */}
      {circleListData?.length >= apiPayload?.limit && <div className=" flex mt-3 justify-center">
        <div onClick={handlerShowMoreCommentsHandler} className="cursor-pointer border border-black rounded-md p-1 px-2 text-sm text-black">Show more</div>
      </div>}
      {/* {circleListData?.length > 0 && (
        <div className="pagination-container mt-4 ">
          <Pagination
            current={currentPage}
            total={circleListData.length}
            pageSize={payload.limit} // Set the number of posts per page
            onChange={handlePageChange} // Handle page change event
          />
        </div>
      )} */}
    </div>
  );
}

export default InnerImgCards;
